var map = {
	"./tutorialIcon1.png": 1162,
	"./tutorialIcon2.png": 8650,
	"./tutorialIcon3.png": 8713,
	"./tutorialIcon4.png": 4411,
	"./tutorialIcon5.png": 2851,
	"./tutorialIcon6.png": 3760,
	"./tutorialIcon7.png": 4093
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4823;